import { StyledFooter, StyledTitle, StyledText } from './Footer.styles';

function Footer() {
  return (
    <StyledFooter>
      <StyledTitle>Monrif.net Srl &ndash; A Company of Monrif Group</StyledTitle>
      <StyledText>Copyright&copy; 2020 &ndash; P.Iva 12741650159</StyledText>
    </StyledFooter>
  );
}

export default Footer;
